import {EmptyString, NonEmptyString} from 'Core/models/EmptyString';
import * as O from 'fp-ts/lib/Option';
import {nanoid} from 'nanoid';
import {ClassNameMap} from '@material-ui/styles/withStyles';
import {
  EmptyChangeAddressRequest,
  ValidChangeAddress,
  AddressChangeRequest,
} from 'Agent/Policies/models/ServiceRequest/AddressChangeRequest';
import {matchChangeRequest} from 'Agent/Policies/models/ServiceRequest/ChangeRequest';
import {
  EmptyDirectBillingScheduleChange,
  ValidChangeDirectBillingSchedule,
} from 'Agent/Policies/models/ServiceRequest/DirectBillingScheduleChangeRequest';
import {
  ChangeType,
  PolicyNumber,
  PremiumMode,
  ValidInitialPolicyServiceRequest,
} from 'Agent/Policies/models/ServiceRequest/InitialPolicyServiceRequest';
import {
  EmptyChangePayrollAllotment,
  ValidChangePayrollAllotment,
} from 'Agent/Policies/models/ServiceRequest/PayrollAllotmentChangeRequest';
import {
  EmptyPolicyServiceRequest,
  matchPolicyServiceRequest,
  PolicyServiceRequest,
} from 'Agent/Policies/models/ServiceRequest/PolicyServiceRequest';
import {
  InvalidServiceRequestWithChange,
  ValidServiceRequestWithChange,
} from 'Agent/Policies/models/ServiceRequest/PolicyServiceRequestWithChangeRequest';
import {createAction} from 'Shared/utilities/actionCreator';
import {Async, Empty, toEither} from 'Core/models/Async';
import {addressType} from '../components/AddressChangeRequest';
import {pipe} from 'fp-ts/lib/pipeable';
import * as E from 'fp-ts/lib/Either';

export enum PolicyServiceRequestActionType {
  CHANGE_POLICY_NUMBER = 'policyServiceRequest/CHANGE_POLICY_NUMBER',
  CHANGE_INSURED_LAST_NAME = 'policyServiceRequest/CHANGE_INSURED_LAST_NAME',
  CHANGE_INSURED_FIRST_NAME = 'policyServiceRequest/CHANGE_INSURED_FIRST_NAME',
  CHANGE_INSURED_MIDDLE_NAME = 'policyServiceRequest/CHANGE_INSURED_MIDDLE_NAME',
  CHANGE_PREMIUM_MODE = 'policyServiceRequest/CHANGE_PREMIUM_MODE',
  CHANGE_ACCOUNT_NUMBER = 'policyServiceRequest/CHANGE_ACCOUNT_NUMBER',
  CHANGE_CONTROL_NUMBER = 'policyServiceRequest/CHANGE_CONTROL_NUMBER',
  CHANGE_PAYOR_NAME = 'policyServiceRequest/CHANGE_PAYOR_NAME',
  CHANGE_PLACE_POLICY_ON_DIRECT_BILL = 'policyServiceRequest/CHANGE_PLACE_POLICY_ON_DIRECT_BILL',
  CHANGE_ADDRESS_LAST_NAME = 'policyServiceRequest/CHANGE_ADDRESS_ADDRESS2',
  CHANGE_ADDRESS_FIRST_NAME = 'policyServiceRequest/CHANGE_ADDRESS_ADDRESS1',
  CHANGE_ADDRESS_MIDDLE_NAME = 'policyServiceRequest/CHANGE_ADDRESS_MIDDLE_NAME',
  CHANGE_ADDRESS_STREET = 'policyServiceRequest/CHANGE_ADDRESS_STREET',
  CHANGE_ADDRESS_CITY = 'policyServiceRequest/CHANGE_ADDRESS_CITY',
  CHANGE_ADDRESS_STATE = 'policyServiceRequest/CHANGE_ADDRESS_STATE',
  CHANGE_ADDRESS_ZIP = 'policyServiceRequest/CHANGE_ADDRESS_ZIP',
  CHANGE_SERVICE_REQUEST_TYPE = 'policyServiceRequest/CHANGE_SERVICE_REQUEST_TYPE',
  CHANGE_ADDITIONAL_POLICIES = 'policyServiceRequest/CHANGE_ADDITIONAL_POLICIES',
  CLEAR = 'policyServiceRequest/CLEAR',
  SUBMIT_INITIAL_REQUEST = 'policyServiceRequest/SUBMIT_INITIAL_REQUEST',
  ADD_ADDITIONAL_POLICY_NUMBER = 'policyServiceRequest/ADD_ADDITIONAL_POLICY_NUMBER',
  REMOVE_ADDITIONAL_POLICY_NUMBER = 'policyServiceRequest/REMOVE_ADDITIONAL_POLICY_NUMBER',
  CHANGE_ADDRESS_REQUEST = 'policyServiceRequest/CHANGE_ADDRESS_REQUEST',
  CHANGE_VALIDATE_ADDRESS = 'policyServiceRequest/CHANGE_VALIDATE_ADDRESS',
  CHANGE_UNVALIDATED_ADDRESS_ACCEPTED = 'policyServiceRequest/CHANGE_UNVALIDATED_ADDRESS_ACCEPTED',
  VALIDATE_ADDRESS = 'policyServiceRequest/VALIDATE_ADDRESS',
  ADDRESS_IS_VALIDATING = 'policyServiceRequest/ADDRESS_IS_VALIDATING',
  CHANGE_FLAG = 'policyServiceRequest/CHANGE_FLAG',
  CHANGE_MISSING_REQUIRED_FIELDS = 'policyServiceRequest/CHANGE_MISSING_REQUIRED_FIELDS',
  SAVE_SERVICE_REQUEST = 'policyServiceRequest/SAVE_SERVICE_REQUEST',
}

export enum RequiredCheckoutCartFields {
  ADDRESS_LINE_1 = 'Address Line 1 ',
  CITY = 'City ',
  ZIP = 'Zip ',
  STATE = 'State ',
}
export type AdrressRequestView = {
  address?: string;
  address2?: string;
  city?: string;
  state?: string;
  zip?: string;
};
type FilterEnum = {
  name: string;
  value: string;
};

export const StateFilter: FilterEnum[] = [
  {
    name: 'Alabama',
    value: 'AL',
  },
  {
    name: 'Alaska',
    value: 'AK',
  },
  {
    name: 'American Samoa',
    value: 'AS',
  },
  {
    name: 'Arizona',
    value: 'AZ',
  },
  {
    name: 'Arkansas',
    value: 'AR',
  },
  {
    name: 'California',
    value: 'CA',
  },
  {
    name: 'Colorado',
    value: 'CO',
  },
  {
    name: 'Connecticut',
    value: 'CT',
  },
  {
    name: 'Delaware',
    value: 'DE',
  },
  {
    name: 'District of Columbia',
    value: 'DC',
  },
  {
    name: 'Florida',
    value: 'FL',
  },
  {
    name: 'Georgia',
    value: 'GA',
  },
  {
    name: 'Guam',
    value: 'GU',
  },
  {
    name: 'Hawaii',
    value: 'HI',
  },
  {
    name: 'Idaho',
    value: 'ID',
  },
  {
    name: 'Illinois',
    value: 'IL',
  },
  {
    name: 'Indiana',
    value: 'IN',
  },
  {
    name: 'Iowa',
    value: 'IA',
  },
  {
    name: 'Kansas',
    value: 'KS',
  },
  {
    name: 'Kentucky',
    value: 'KY',
  },
  {
    name: 'Louisiana',
    value: 'LA',
  },
  {
    name: 'Maine',
    value: 'ME',
  },
  {
    name: 'Maryland',
    value: 'MD',
  },
  {
    name: 'Massachusetts',
    value: 'MA',
  },
  {
    name: 'Michigan',
    value: 'MI',
  },
  {
    name: 'Minnesota',
    value: 'MN',
  },
  {
    name: 'Mississippi',
    value: 'MS',
  },
  {
    name: 'Missouri',
    value: 'MO',
  },
  {
    name: 'Montana',
    value: 'MT',
  },
  {
    name: 'Nebraska',
    value: 'NE',
  },
  {
    name: 'Nevada',
    value: 'NV',
  },
  {
    name: 'New Hampshire',
    value: 'NH',
  },
  {
    name: 'New Jersey',
    value: 'NJ',
  },
  {
    name: 'New Mexico',
    value: 'NM',
  },
  {
    name: 'New York',
    value: 'NY',
  },
  {
    name: 'North Carolina',
    value: 'NC',
  },
  {
    name: 'North Dakota',
    value: 'ND',
  },
  {
    name: 'Northern Mariana Islands',
    value: 'MP',
  },
  {
    name: 'Ohio',
    value: 'OH',
  },
  {
    name: 'Oklahoma',
    value: 'OK',
  },
  {
    name: 'Oregon',
    value: 'OR',
  },
  {
    name: 'Pennsylvania',
    value: 'PA',
  },
  {
    name: 'Puerto Rico',
    value: 'PR',
  },
  {
    name: 'Rhode Island',
    value: 'RI',
  },
  {
    name: 'South Carolina',
    value: 'SC',
  },
  {
    name: 'South Dakota',
    value: 'SD',
  },
  {
    name: 'Tennessee',
    value: 'TN',
  },
  {
    name: 'Texas',
    value: 'TX',
  },
  {
    name: 'Utah',
    value: 'UT',
  },
  {
    name: 'Vermont',
    value: 'VT',
  },
  {
    name: 'Virginia',
    value: 'VA',
  },
  {
    name: 'Washington',
    value: 'WA',
  },
  {
    name: 'West Virginia',
    value: 'WV',
  },
  {
    name: 'Wisconsin',
    value: 'WI',
  },
  {
    name: 'Wyoming',
    value: 'WY',
  },
  {
    name: 'U.S. Virgin Islands',
    value: 'VI',
  },
];
export const selectAddress = (
  addressValidationResponse: Async<AddressResponse>,
  setCart: addressType,
  cart: AddressChangeRequest,
  setAddressConfirmed: React.Dispatch<React.SetStateAction<boolean>>
) => {
  pipe(
    toEither(addressValidationResponse),
    E.fold(
      () => {},
      address => {
        setCart({
          ...cart,
          address: address.address,
          address2: address.address2,
          city: address.city,
          state: address.state,
          zip: address.zip,
        });
        return setAddressConfirmed(true);
      }
    )
  );
};
export const stepHandleNext = (
  dispatch: React.Dispatch<any>,
  changeMissingRequiredFields: any,
  missingRequiredFields: string[],
  addressParam: AddressChangeRequest
) => {
  dispatch(changeMissingRequiredFields([]));
  handleFieldValidation(RequiredCheckoutCartFields.ADDRESS_LINE_1, addressParam.address, missingRequiredFields);
  handleFieldValidation(RequiredCheckoutCartFields.CITY, addressParam.city, missingRequiredFields);
  handleFieldValidation(RequiredCheckoutCartFields.ZIP, addressParam.zip, missingRequiredFields);
  handleFieldValidation(RequiredCheckoutCartFields.STATE, addressParam.state, missingRequiredFields);
  dispatch(changeMissingRequiredFields(missingRequiredFields));
};
export const getButtonValue = (
  addressParam: AddressChangeRequest,
  unValidatedAddressAccepted: boolean,
  classes: ClassNameMap<'root' | 'button' | 'disabledButton' | 'actionsContainer'>
) => {
  if (addressParam.key == 'ValidChangeAddress' && addressParam.key.length >= 1) {
    return unValidatedAddressAccepted ? classes.button : classes.disabledButton;
  } else {
    return classes.disabledButton;
  }
};

export function handleFieldValidation(enumValue: any, field: string | undefined, missingRequiredFields: string[]) {
  if (!field || field?.length < 1) {
    missingRequiredFields.push(enumValue);
  } else {
    if (missingRequiredFields.indexOf(enumValue.toString()) > -1) {
      let indexToRemove = missingRequiredFields.indexOf(enumValue.toString());
      while (indexToRemove > -1) {
        missingRequiredFields.splice(indexToRemove, 1);
        indexToRemove = missingRequiredFields.indexOf(enumValue.toString());
      }
    }
  }
}

export const setAddress = (e: any, setAddressParam: addressType, addressParam: AddressChangeRequest) => {
  if (e.target.name == 'address') {
    setAddressParam({...addressParam, address: e.target.value});
  } else if (e.target.name == 'address2') {
    setAddressParam({...addressParam, address2: e.target.value});
  } else if (e.target.name == 'city') {
    setAddressParam({...addressParam, city: e.target.value});
  } else if (e.target.name == 'state') {
    setAddressParam({...addressParam, state: e.target.value});
  } else if (e.target.name == 'zip') {
    const onlyNums = e.target.value.replace(/[^0-9]/g, '');
    if (onlyNums.length <= 5) {
      setAddressParam({...addressParam, ['zip']: onlyNums});
    } else if (onlyNums.length <= 9) {
      const value = onlyNums.substring(0, 5) + '-' + onlyNums.substring(5, onlyNums.length);
      setAddressParam({...addressParam, ['zip']: value});
    }
  }
};
export function addressSelection(addressValidationResponse: Async<AddressResponse>) {
  return pipe(
    toEither(addressValidationResponse),
    E.fold(
      () => {
        return '';
      },
      address => {
        if (address.address2 === null || address.address2.length > 1) {
          return address.address + ', ' + address.city + ', ' + address.state + ' ' + address.zip;
        } else {
          return (
            address.address + ': ' + address.address2 + ', ' + address.city + ', ' + address.state + ' ' + address.zip
          );
        }
      }
    )
  );
}

export const clear = () => createAction(PolicyServiceRequestActionType.CLEAR);
export const savePolicyServiceRequest = (encryptedIdentifier: string, serviceRequest: ValidServiceRequestWithChange) =>
  createAction(PolicyServiceRequestActionType.SAVE_SERVICE_REQUEST, {encryptedIdentifier, serviceRequest});
export const submitInitialRequest = (validInitialRequest: ValidInitialPolicyServiceRequest) =>
  createAction(PolicyServiceRequestActionType.SUBMIT_INITIAL_REQUEST, {validInitialRequest});
export const changeRequestType = (changeType: ChangeType) =>
  createAction(PolicyServiceRequestActionType.CHANGE_SERVICE_REQUEST_TYPE, {changeType});
export const changeAdditionalPolicies = (additionalPolicyId: string, policyNumber: string) =>
  createAction(PolicyServiceRequestActionType.CHANGE_ADDITIONAL_POLICIES, {additionalPolicyId, policyNumber});
export const addAdditionalPolicyNumber = () =>
  createAction(PolicyServiceRequestActionType.ADD_ADDITIONAL_POLICY_NUMBER);
export const removeAdditionalPolicyNumber = (additionalPolicyId: string) =>
  createAction(PolicyServiceRequestActionType.REMOVE_ADDITIONAL_POLICY_NUMBER, {additionalPolicyId});
export const changePolicyNumber = (policyNumber: string) =>
  createAction(PolicyServiceRequestActionType.CHANGE_POLICY_NUMBER, {policyNumber});
export const changeInsuredLastName = (insuredLastName: string) =>
  createAction(PolicyServiceRequestActionType.CHANGE_INSURED_LAST_NAME, {insuredLastName});
export const changeInsuredFirstName = (insuredFirstName: string) =>
  createAction(PolicyServiceRequestActionType.CHANGE_INSURED_FIRST_NAME, {insuredFirstName});
export const changeInsuredMiddleName = (insuredMiddleName: string) =>
  createAction(PolicyServiceRequestActionType.CHANGE_INSURED_MIDDLE_NAME, {insuredMiddleName});
export const changePremiumMode = (premiumMode: PremiumMode) =>
  createAction(PolicyServiceRequestActionType.CHANGE_PREMIUM_MODE, {premiumMode});
export const changeAccountNumber = (accountNumber: string) =>
  createAction(PolicyServiceRequestActionType.CHANGE_ACCOUNT_NUMBER, {accountNumber});
export const changeControlNumber = (controlNumber: string) =>
  createAction(PolicyServiceRequestActionType.CHANGE_CONTROL_NUMBER, {controlNumber});
export const changePayorName = (payorName: string) =>
  createAction(PolicyServiceRequestActionType.CHANGE_PAYOR_NAME, {payorName});
export const changePlacePolicyOnDirectBill = (placePolicyOnBill: PremiumMode) =>
  createAction(PolicyServiceRequestActionType.CHANGE_PLACE_POLICY_ON_DIRECT_BILL, {placePolicyOnBill});
export const changeAddressLastName = (address2: string) =>
  createAction(PolicyServiceRequestActionType.CHANGE_ADDRESS_LAST_NAME, {address2});
export const changeAddressFirstName = (address: string) =>
  createAction(PolicyServiceRequestActionType.CHANGE_ADDRESS_FIRST_NAME, {address});
export const changeAddressState = (state: any) =>
  createAction(PolicyServiceRequestActionType.CHANGE_ADDRESS_STATE, {state});
export const changeAddressCity = (city: string) =>
  createAction(PolicyServiceRequestActionType.CHANGE_ADDRESS_CITY, {city});
export const changeAddressZip = (zip: string) => createAction(PolicyServiceRequestActionType.CHANGE_ADDRESS_ZIP, {zip});
export const changeValidateAddress = (address: Async<AddressResponse>) =>
  createAction(PolicyServiceRequestActionType.CHANGE_VALIDATE_ADDRESS, {address});
export const changeMissingRequiredFields = (missingRequiredFields: string[]) =>
  createAction(PolicyServiceRequestActionType.CHANGE_MISSING_REQUIRED_FIELDS, {missingRequiredFields});
export const changeUnValidatedAddressAccepted = (unValidatedAddressAccepted: boolean) =>
  createAction(PolicyServiceRequestActionType.CHANGE_UNVALIDATED_ADDRESS_ACCEPTED, {unValidatedAddressAccepted});
export const validateAddress = (address: AddressChangeRequest, missingRequiredFields: string[]) =>
  createAction(PolicyServiceRequestActionType.VALIDATE_ADDRESS, {
    address,
    missingRequiredFields,
  });
export const addressIsValidating = (isValidating: boolean) =>
  createAction(PolicyServiceRequestActionType.ADDRESS_IS_VALIDATING, {isValidating});
export const changeFlag = (flag: boolean) => createAction(PolicyServiceRequestActionType.CHANGE_FLAG, {flag});

export type AddressResponse = {
  validationMessage: string;
  addressValidatedCode: string;
  address: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
};
export const DEFAULT_STATE: PolicyServiceRequestState = {
  serviceRequest: EmptyPolicyServiceRequest,
  addressValidationResponse: new Empty(),
  unValidatedAddressAccepted: false,
  flag: false,
  missingRequiredFields: [],
  isAddressValidating: false,
  address: EmptyChangeAddressRequest,
};

export function addressIsChanged(cart: AddressChangeRequest, addressValidationResponse: Async<AddressResponse>) {
  if (addressValidationResponse.key !== 'Loaded') {
    return true;
  } else {
    return pipe(
      toEither(addressValidationResponse),
      E.fold(
        () => {
          return true;
        },
        address => {
          if (
            address &&
            address.address === cart.address &&
            address.address2 === cart.address2 &&
            address.zip === cart.zip &&
            address.state === cart.state &&
            address.city === cart.city
          ) {
            return false;
          } else {
            return true;
          }
        }
      )
    );
  }
}

export type PolicyServiceRequestState = {
  serviceRequest: PolicyServiceRequest;
  addressValidationResponse: Async<AddressResponse>;
  unValidatedAddressAccepted: boolean;
  flag: boolean;
  missingRequiredFields: string[];
  isAddressValidating: boolean;
  address: AddressChangeRequest;
};
export function isAddressValidated(addressValidationResponse: Async<AddressResponse>) {
  if (addressValidationResponse.key !== 'Loaded') {
    return false;
  }
  return pipe(
    toEither(addressValidationResponse),
    E.fold(
      () => {
        return false;
      },
      address => {
        if (address && address.addressValidatedCode === '0002') return true;
      }
    )
  );
}

type PolicyServiceRequestAction =
  | ReturnType<typeof addAdditionalPolicyNumber>
  | ReturnType<typeof changeAdditionalPolicies>
  | ReturnType<typeof removeAdditionalPolicyNumber>
  | ReturnType<typeof submitInitialRequest>
  | ReturnType<typeof changeRequestType>
  | ReturnType<typeof clear>
  | ReturnType<typeof changePolicyNumber>
  | ReturnType<typeof changeInsuredFirstName>
  | ReturnType<typeof changeInsuredLastName>
  | ReturnType<typeof changeInsuredMiddleName>
  | ReturnType<typeof changePremiumMode>
  | ReturnType<typeof changeAccountNumber>
  | ReturnType<typeof changeControlNumber>
  | ReturnType<typeof changePayorName>
  | ReturnType<typeof changePlacePolicyOnDirectBill>
  | ReturnType<typeof changeAddressLastName>
  | ReturnType<typeof changeAddressFirstName>
  | ReturnType<typeof changeAddressCity>
  | ReturnType<typeof changeAddressState>
  | ReturnType<typeof changeUnValidatedAddressAccepted>
  | ReturnType<typeof changeFlag>
  | ReturnType<typeof addressIsValidating>
  | ReturnType<typeof changeValidateAddress>
  | ReturnType<typeof validateAddress>
  | ReturnType<typeof changeMissingRequiredFields>
  | ReturnType<typeof changeAddressZip>;

export default (
  state: PolicyServiceRequestState = DEFAULT_STATE,
  action: PolicyServiceRequestAction
): PolicyServiceRequestState => {
  switch (action.type) {
    case PolicyServiceRequestActionType.CLEAR:
      return DEFAULT_STATE;
    case PolicyServiceRequestActionType.CHANGE_ADDITIONAL_POLICIES:
      const mergeAdditionalPolicyNumbers = (policyNumbers: PolicyNumber[]) =>
        policyNumbers.map(policyNum =>
          policyNum.id !== action.payload.additionalPolicyId
            ? policyNum
            : {id: action.payload.additionalPolicyId, value: NonEmptyString.create(action.payload.policyNumber)}
        );

      return matchPolicyServiceRequest(state.serviceRequest, {
        Initial: initial => ({
          ...state,
          serviceRequest: ValidInitialPolicyServiceRequest.create(
            initial.policyNumber,
            initial.insuredLastName,
            initial.insuredFirstName,
            initial.insuredMiddleName,
            mergeAdditionalPolicyNumbers(initial.additionalPolicyNumbers),
            initial.requestChangeType
          ),
        }),
        WithChangeRequest: () => state,
      });
    case PolicyServiceRequestActionType.CHANGE_MISSING_REQUIRED_FIELDS:
      return {
        ...state,
        missingRequiredFields: action.payload.missingRequiredFields,
      };
    case PolicyServiceRequestActionType.ADDRESS_IS_VALIDATING:
      return {
        ...state,
        isAddressValidating: action.payload.isValidating,
      };
    case PolicyServiceRequestActionType.CHANGE_UNVALIDATED_ADDRESS_ACCEPTED:
      return {
        ...state,
        unValidatedAddressAccepted: action.payload.unValidatedAddressAccepted,
      };
    case PolicyServiceRequestActionType.CHANGE_VALIDATE_ADDRESS:
      return {
        ...state,
        addressValidationResponse: action.payload.address,
      };
    case PolicyServiceRequestActionType.VALIDATE_ADDRESS:
      return {
        ...state,
        address: action.payload.address,
        missingRequiredFields: action.payload.missingRequiredFields,
      };
    case PolicyServiceRequestActionType.ADD_ADDITIONAL_POLICY_NUMBER:
      return matchPolicyServiceRequest(state.serviceRequest, {
        Initial: initial => ({
          ...state,
          serviceRequest: ValidInitialPolicyServiceRequest.create(
            initial.policyNumber,
            initial.insuredLastName,
            initial.insuredFirstName,
            initial.insuredMiddleName,
            [...initial.additionalPolicyNumbers, {id: nanoid(), value: new EmptyString()}],
            initial.requestChangeType
          ),
        }),
        WithChangeRequest: () => state,
      });
    case PolicyServiceRequestActionType.CHANGE_POLICY_NUMBER:
      return matchPolicyServiceRequest(state.serviceRequest, {
        Initial: initial => ({
          ...state,
          serviceRequest: ValidInitialPolicyServiceRequest.create(
            NonEmptyString.create(action.payload.policyNumber),
            initial.insuredLastName,
            initial.insuredFirstName,
            initial.insuredMiddleName,
            initial.additionalPolicyNumbers,
            initial.requestChangeType
          ),
        }),
        WithChangeRequest: () => state,
      });
    case PolicyServiceRequestActionType.CHANGE_INSURED_FIRST_NAME:
      return matchPolicyServiceRequest(state.serviceRequest, {
        Initial: initial => ({
          ...state,
          serviceRequest: ValidInitialPolicyServiceRequest.create(
            initial.policyNumber,
            initial.insuredLastName,
            NonEmptyString.create(action.payload.insuredFirstName),
            initial.insuredMiddleName,
            initial.additionalPolicyNumbers,
            initial.requestChangeType
          ),
        }),
        WithChangeRequest: () => state,
      });
    case PolicyServiceRequestActionType.CHANGE_INSURED_LAST_NAME:
      return matchPolicyServiceRequest(state.serviceRequest, {
        Initial: initial => ({
          ...state,
          serviceRequest: ValidInitialPolicyServiceRequest.create(
            initial.policyNumber,
            NonEmptyString.create(action.payload.insuredLastName),
            initial.insuredFirstName,
            initial.insuredMiddleName,
            initial.additionalPolicyNumbers,
            initial.requestChangeType
          ),
        }),
        WithChangeRequest: () => state,
      });
    case PolicyServiceRequestActionType.CHANGE_INSURED_MIDDLE_NAME:
      return matchPolicyServiceRequest(state.serviceRequest, {
        Initial: initial => ({
          ...state,
          serviceRequest: ValidInitialPolicyServiceRequest.create(
            initial.policyNumber,
            initial.insuredLastName,
            initial.insuredFirstName,
            NonEmptyString.create(action.payload.insuredMiddleName),
            initial.additionalPolicyNumbers,
            initial.requestChangeType
          ),
        }),
        WithChangeRequest: () => state,
      });
    case PolicyServiceRequestActionType.REMOVE_ADDITIONAL_POLICY_NUMBER:
      return matchPolicyServiceRequest(state.serviceRequest, {
        Initial: initial => ({
          ...state,
          serviceRequest: ValidInitialPolicyServiceRequest.create(
            initial.policyNumber,
            initial.insuredLastName,
            initial.insuredFirstName,
            initial.insuredMiddleName,
            initial.additionalPolicyNumbers.filter(
              policyNumber => policyNumber.id !== action.payload.additionalPolicyId
            ),
            initial.requestChangeType
          ),
        }),
        WithChangeRequest: () => state,
      });
    case PolicyServiceRequestActionType.CHANGE_SERVICE_REQUEST_TYPE:
      return matchPolicyServiceRequest(state.serviceRequest, {
        Initial: initial => ({
          ...state,
          serviceRequest: ValidInitialPolicyServiceRequest.create(
            initial.policyNumber,
            initial.insuredLastName,
            initial.insuredFirstName,
            initial.insuredMiddleName,
            initial.additionalPolicyNumbers,
            O.fromNullable(action.payload.changeType)
          ),
        }),
        WithChangeRequest: () => state,
      });
    case PolicyServiceRequestActionType.SUBMIT_INITIAL_REQUEST:
      const emptyChangeRequest =
        action.payload.validInitialRequest.requestChangeType.value === ChangeType.AddressChange
          ? EmptyChangeAddressRequest
          : action.payload.validInitialRequest.requestChangeType.value === ChangeType.BillingScheduleChange
          ? EmptyDirectBillingScheduleChange
          : EmptyChangePayrollAllotment;

      return {
        ...state,
        serviceRequest: new InvalidServiceRequestWithChange(action.payload.validInitialRequest, emptyChangeRequest),
      };
    case PolicyServiceRequestActionType.CHANGE_ADDRESS_FIRST_NAME:
      return matchPolicyServiceRequest(state.serviceRequest, {
        Initial: () => state,
        WithChangeRequest: withChangeRequest => ({
          ...state,
          serviceRequest: matchChangeRequest(withChangeRequest.changeRequest, {
            AddressChangeRequest: address => {
              return ValidServiceRequestWithChange.create(
                withChangeRequest.initialPolicyServiceRequestInformation,
                ValidChangeAddress.create(
                  action.payload.address,
                  address.address2,

                  address.city,
                  address.state,
                  address.zip
                )
              );
            },
            default: () => withChangeRequest,
          }),
        }),
      });

    case PolicyServiceRequestActionType.CHANGE_ADDRESS_LAST_NAME:
      return matchPolicyServiceRequest(state.serviceRequest, {
        Initial: () => state,
        WithChangeRequest: withChangeRequest => ({
          ...state,
          serviceRequest: matchChangeRequest(withChangeRequest.changeRequest, {
            AddressChangeRequest: address => {
              return ValidServiceRequestWithChange.create(
                withChangeRequest.initialPolicyServiceRequestInformation,
                ValidChangeAddress.create(
                  address.address,
                  action.payload.address2,
                  address.city,
                  address.state,
                  address.zip
                )
              );
            },
            default: () => withChangeRequest,
          }),
        }),
      });
    case PolicyServiceRequestActionType.CHANGE_FLAG:
      return {
        ...state,
        flag: action.payload.flag,
      };
    case PolicyServiceRequestActionType.CHANGE_ADDRESS_CITY:
      return matchPolicyServiceRequest(state.serviceRequest, {
        Initial: () => state,
        WithChangeRequest: withChangeRequest => ({
          ...state,
          serviceRequest: matchChangeRequest(withChangeRequest.changeRequest, {
            AddressChangeRequest: address =>
              ValidServiceRequestWithChange.create(
                withChangeRequest.initialPolicyServiceRequestInformation,
                ValidChangeAddress.create(
                  address.address,
                  address.address2,
                  action.payload.city,
                  address.state,
                  address.zip
                )
              ),
            default: () => withChangeRequest,
          }),
        }),
      });
    case PolicyServiceRequestActionType.CHANGE_ADDRESS_ZIP:
      return matchPolicyServiceRequest(state.serviceRequest, {
        Initial: () => state,
        WithChangeRequest: withChangeRequest => ({
          ...state,
          serviceRequest: matchChangeRequest(withChangeRequest.changeRequest, {
            AddressChangeRequest: address => {
              return ValidServiceRequestWithChange.create(
                withChangeRequest.initialPolicyServiceRequestInformation,
                ValidChangeAddress.create(
                  address.address,
                  address.address2,
                  address.city,

                  address.state,
                  action.payload.zip
                )
              );
            },
            default: () => withChangeRequest,
          }),
        }),
      });
    case PolicyServiceRequestActionType.CHANGE_ADDRESS_STATE:
      return matchPolicyServiceRequest(state.serviceRequest, {
        Initial: () => state,
        WithChangeRequest: withChangeRequest => ({
          ...state,
          serviceRequest: matchChangeRequest(withChangeRequest.changeRequest, {
            AddressChangeRequest: address => {
              return ValidServiceRequestWithChange.create(
                withChangeRequest.initialPolicyServiceRequestInformation,
                ValidChangeAddress.create(
                  address.address,
                  address.address2,
                  address.city,

                  action.payload.state,
                  address.zip
                )
              );
            },
            default: () => withChangeRequest,
          }),
        }),
      });

    case PolicyServiceRequestActionType.CHANGE_PREMIUM_MODE:
      return matchPolicyServiceRequest(state.serviceRequest, {
        Initial: () => state,
        WithChangeRequest: withChangeRequest => ({
          ...state,
          serviceRequest: matchChangeRequest(withChangeRequest.changeRequest, {
            DirectBillingChangeRequest: () =>
              ValidServiceRequestWithChange.create(
                withChangeRequest.initialPolicyServiceRequestInformation,
                //@ts-ignore
                ValidChangeDirectBillingSchedule.create(O.fromNullable(action.payload.premiumMode))
              ),
            default: () => withChangeRequest,
          }),
        }),
      });
    case PolicyServiceRequestActionType.CHANGE_ACCOUNT_NUMBER:
      return matchPolicyServiceRequest(state.serviceRequest, {
        Initial: () => state,
        WithChangeRequest: withChangeRequest => ({
          ...state,
          serviceRequest: matchChangeRequest(withChangeRequest.changeRequest, {
            PayrollAllotmentChangeRequest: payrollChange =>
              ValidServiceRequestWithChange.create(
                withChangeRequest.initialPolicyServiceRequestInformation,
                ValidChangePayrollAllotment.create(
                  NonEmptyString.create(action.payload.accountNumber),
                  payrollChange.controlNumber,
                  payrollChange.payorName,
                  payrollChange.billingSchedule
                )
              ),
            default: () => withChangeRequest,
          }),
        }),
      });
    case PolicyServiceRequestActionType.CHANGE_CONTROL_NUMBER:
      return matchPolicyServiceRequest(state.serviceRequest, {
        Initial: () => state,
        WithChangeRequest: withChangeRequest => ({
          ...state,
          serviceRequest: matchChangeRequest(withChangeRequest.changeRequest, {
            PayrollAllotmentChangeRequest: payrollChange =>
              ValidServiceRequestWithChange.create(
                withChangeRequest.initialPolicyServiceRequestInformation,
                ValidChangePayrollAllotment.create(
                  payrollChange.accountNumber,
                  NonEmptyString.create(action.payload.controlNumber),
                  payrollChange.payorName,
                  payrollChange.billingSchedule
                )
              ),
            default: () => withChangeRequest,
          }),
        }),
      });
    case PolicyServiceRequestActionType.CHANGE_PAYOR_NAME:
      return matchPolicyServiceRequest(state.serviceRequest, {
        Initial: () => state,
        WithChangeRequest: withChangeRequest => ({
          ...state,
          serviceRequest: matchChangeRequest(withChangeRequest.changeRequest, {
            PayrollAllotmentChangeRequest: payrollChange =>
              ValidServiceRequestWithChange.create(
                withChangeRequest.initialPolicyServiceRequestInformation,
                ValidChangePayrollAllotment.create(
                  payrollChange.accountNumber,
                  payrollChange.controlNumber,
                  NonEmptyString.create(action.payload.payorName),
                  payrollChange.billingSchedule
                )
              ),
            default: () => withChangeRequest,
          }),
        }),
      });
    case PolicyServiceRequestActionType.CHANGE_PLACE_POLICY_ON_DIRECT_BILL:
      return matchPolicyServiceRequest(state.serviceRequest, {
        Initial: () => state,
        WithChangeRequest: withChangeRequest => ({
          ...state,
          serviceRequest: matchChangeRequest(withChangeRequest.changeRequest, {
            PayrollAllotmentChangeRequest: payrollChange =>
              ValidServiceRequestWithChange.create(
                withChangeRequest.initialPolicyServiceRequestInformation,
                ValidChangePayrollAllotment.create(
                  payrollChange.accountNumber,
                  payrollChange.controlNumber,
                  payrollChange.payorName,
                  O.fromNullable(action.payload.placePolicyOnBill)
                )
              ),
            default: () => withChangeRequest,
          }),
        }),
      });
    default:
      return state;
  }
};
